import React, { forwardRef } from "react";
import { FieldError } from "react-hook-form";
import classNames from "classnames";

import { ICheckboxField } from "types";
import { FormRequired } from "../components";

interface CheckboxFieldProps extends ICheckboxField {
  error?: FieldError | null;
}
export const CheckboxField = forwardRef<
  HTMLInputElement,
  CheckboxFieldProps & React.InputHTMLAttributes<HTMLInputElement>
>(({ id, label, value, type, error, required, onChange, ...rest }, ref) => {
  return (
    <div className="field field--checkbox">
      <label className="form-checkbox" htmlFor={id}>
        <input
          ref={ref}
          className={classNames("form-checkbox__input", [
            error?.message && "is-error",
          ])}
          id={id}
          value={value}
          type="checkbox"
          onChange={onChange}
          {...rest}
          name={id}
        />
        <span className="form-checkbox__label">
          {label}
          {required && <FormRequired />}
        </span>
      </label>
      {error?.message && (
        <span className="form-message is-error is-animated" role="alert">
          {error?.message}
        </span>
      )}
    </div>
  );
});
